import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useHistory } from "react-router-dom";
import ApiService from "../../services/api-service";
import { useDispatch } from "react-redux";
import { addSongAction } from "../../action/songs";
import "../../pages/Home/Home.scss";

export default function FeaturedMusic() {
  const [featuredMusic, setFeaturedMusic] = useState([]);
  const [loading, setLoading] = useState(true);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchFeaturedMusic = async () => {
      try {
        setLoading(true);
        const response = await ApiService.GET_FEATURED_MUSIC(1, 7);
        if (response?.result) {
          setFeaturedMusic(response.result);
        }
      } catch (error) {
        console.error("Error fetching featured music:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFeaturedMusic();
  }, []);

  const handleMusicClick = (music) => {
    dispatch(addSongAction(music));
  };

  if (loading || featuredMusic.length === 0) {
    return null;
  }

  return (
    <section className="siki-featured-section siki-fade-up">
      <div className="siki-section-label">Now Playing</div>
      <div className="siki-section-header">
        <h2 className="siki-section-title">Featured Music</h2>
        <div className="siki-section-action" onClick={() => history.push("/app/feature/music")}>
          See All →
        </div>
      </div>

      <div className="siki-bento-grid">
        {/* Hero card - first track */}
        {featuredMusic[0] && (
          <div
            className="siki-bento-card hero"
            onClick={() => handleMusicClick(featuredMusic[0])}
          >
            <img
              className="siki-card-img"
              src={featuredMusic[0].thumbnailImg?.filePath || featuredMusic[0].thumbnail?.url || "https://via.placeholder.com/400"}
              alt={featuredMusic[0].title || "Music"}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/400?text=No+Image";
              }}
            />
            <div className="siki-card-overlay">
              <div className="siki-card-tag">Editors Pick</div>
              <div className="siki-card-title">{featuredMusic[0].title || "Untitled"}</div>
              <div className="siki-card-artist">
                {featuredMusic[0].artistData?.[0]?.displayArtistName || featuredMusic[0].artistData?.[0]?.fullName || featuredMusic[0].uploader?.firstName || featuredMusic[0].artistInString || "Unknown Artist"}
              </div>
            </div>
            <div className="siki-card-play">
              <svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21"/></svg>
            </div>
          </div>
        )}

        {/* Wide cards - cards 2 & 3 */}
        {featuredMusic[1] && (
          <div
            className="siki-bento-card wide"
            onClick={() => handleMusicClick(featuredMusic[1])}
          >
            <img
              className="siki-card-img"
              src={featuredMusic[1].thumbnailImg?.filePath || featuredMusic[1].thumbnail?.url || "https://via.placeholder.com/400"}
              alt={featuredMusic[1].title || "Music"}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/400?text=No+Image";
              }}
            />
            <div className="siki-card-overlay">
              <div className="siki-card-tag">Trending</div>
              <div className="siki-card-title">{featuredMusic[1].title || "Untitled"}</div>
              <div className="siki-card-artist">
                {featuredMusic[1].artistData?.[0]?.displayArtistName || featuredMusic[1].artistData?.[0]?.fullName || featuredMusic[1].uploader?.firstName || "Unknown Artist"}
              </div>
            </div>
            <div className="siki-card-play">
              <svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21"/></svg>
            </div>
          </div>
        )}

        {featuredMusic[2] && (
          <div
            className="siki-bento-card wide"
            onClick={() => handleMusicClick(featuredMusic[2])}
          >
            <img
              className="siki-card-img"
              src={featuredMusic[2].thumbnailImg?.filePath || featuredMusic[2].thumbnail?.url || "https://via.placeholder.com/400"}
              alt={featuredMusic[2].title || "Music"}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/400?text=No+Image";
              }}
            />
            <div className="siki-card-overlay">
              <div className="siki-card-title">{featuredMusic[2].title || "Untitled"}</div>
              <div className="siki-card-artist">
                {featuredMusic[2].artistData?.[0]?.displayArtistName || featuredMusic[2].artistData?.[0]?.fullName || featuredMusic[2].uploader?.firstName || featuredMusic[2].artistInString || "Unknown Artist"}
              </div>
            </div>
            <div className="siki-card-play">
              <svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21"/></svg>
            </div>
          </div>
        )}

        {/* Square cards - cards 4, 5, 6, 7 */}
        {featuredMusic.slice(3, 7).map((music) => (
          <div
            key={music._id}
            className="siki-bento-card square"
            onClick={() => handleMusicClick(music)}
          >
            <img
              className="siki-card-img"
              src={music.thumbnailImg?.filePath || music.thumbnail?.url || "https://via.placeholder.com/400"}
              alt={music.title || "Music"}
              onError={(e) => {
                e.target.src = "https://via.placeholder.com/400?text=No+Image";
              }}
            />
            <div className="siki-card-overlay">
              <div className="siki-card-title">{music.title || "Untitled"}</div>
              <div className="siki-card-artist">
                {music.artistData?.[0]?.displayArtistName || music.artistData?.[0]?.fullName || music.uploader?.firstName || music.artistInString || "Unknown Artist"}
              </div>
            </div>
            <div className="siki-card-play">
              <svg viewBox="0 0 24 24"><polygon points="5,3 19,12 5,21"/></svg>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
